import React from 'react';
import PropTypes from 'prop-types';
import './styles/sensor.scss';
import * as deviceStates from './constants/deviceStates';
import Tooltip from '@material-ui/core/Tooltip';
import Moment from 'react-moment';

const Sensor = props => {
  const { name, data, onClick } = props;

  let errorState = deviceStates.UNKNOWN;
  let sensorState = {};
  let trafficData = {
    qKfzG: -4, qLkwG: -4, qPkwG: -4,
    vKfzG: -4, vLkwG: -4, vPkwG: -4,
    intervalLength: -4
  };
  let trafficSituation = {trafficSituation: 0};

  if(data !== undefined && data.device.sensor_state != null) {
    sensorState = data.device.sensor_state;
    errorState = sensorState.error_state;
    trafficData = data.device.traffic_data;
    trafficSituation = data.device.traffic_situation;
    // console.log(name, errorState)
    // console.log(trafficData)
    //console.log("sensor", errorState);
  }
  
  const malfunction = errorState === deviceStates.MALFUNCTION || errorState === deviceStates.COMMUNICATION_FAILURE;

  let value = "?";

  if(errorState === deviceStates.OK) {
    if(trafficData.vKfzG < 0) {
      value = "N/A";
    } else {
      value = trafficData.vKfzG;
    }
  } else if(malfunction) {
    value = "ERR";
  }

  return (
    <div onClick={onClick}>
        <div className="sensor">
            <div className="senorLabel">{name}</div>
            <Tooltip placement="top" title={
              <React.Fragment>
                <p><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></p>
                <p>{"Intervall: " + (trafficData.intervalLength < 0 ? "N/A" : trafficData.intervalLength + " s")}</p>
                <p>{"qKfz: " + (trafficData.qKfzG < 0 ? "N/A" : trafficData.qKfzG  + " Fz/h")}</p>
                <p>{"qLkw: " + (trafficData.qLkwG < 0 ? "N/A" : trafficData.qLkwG  + " Fz/h")}</p>
                <p>{"qPkw: " + (trafficData.qPkwG < 0 ? "N/A" : trafficData.qPkwG  + " Fz/h")}</p>
                <p>{"vKfz: " + (trafficData.vKfzG < 0 ? "N/A" : trafficData.vKfzG + " km/h")}</p>
                <p>{"vLkw: " + (trafficData.vLkwG < 0 ? "N/A" : trafficData.vLkwG + " km/h")}</p>
                <p>{"vPkw: " + (trafficData.vPkwG < 0 ? "N/A" : trafficData.vPkwG + " km/h")}</p>
                {/* <p>{"Verkehrslage: " +  trafficSituation.trafficSituation}</p> */}
              </React.Fragment>}>
            <div className={"senorValue level-" + trafficSituation.trafficSituation}>{value}</div>
            </Tooltip>
        </div>
    </div>
  );
};

Sensor.propTypes = {
   name: PropTypes.string.isRequired,
   data: PropTypes.object,
   error: PropTypes.object,
   loading: PropTypes.bool.isRequired
};

export default Sensor;
